import { createUserManager } from 'redux-oidc';
import { IDENTITY_CONFIG } from "../utils/authConst";

const userManager = createUserManager(IDENTITY_CONFIG);

export default userManager;